import { render, staticRenderFns } from "./ReasonDialog.component.vue?vue&type=template&id=e519d2ac"
import script from "./ReasonDialog.component.vue?vue&type=script&lang=ts"
export * from "./ReasonDialog.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports